<template>
  <div>
    <MainNav ref="nav" />

    <!-- APP -->
    <div v-if="$root.app" class="pages">
      <transition :name="transitionName">
        <keep-alive exclude="Artist,Gallery,Partner,Intro">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </transition>
    </div>

    <!-- WEBSITE -->
    <div v-else class="pages">
      <keep-alive exclude="Artist,Gallery,Partner,Intro">
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import MainNav from './components/MainNav';

export default {
  name: 'App',
  components: { MainNav },
  data() {
    return {
      transitionName: '',
      transitionOverride: null,
      hasSeenIntro: localStorage.getItem('hasSeenIntro'),
    };
  },
  watch: {
    $route(to, from) {
      document.body.classList.remove('stop-scroll');

      if (to.meta.page >= from.meta.page) {
        window.scrollTo(0, 0);
      }

      let transitionName = to.meta.page > from.meta.page ? 'next' : 'prev';

      if (to.meta.page === from.meta.page) {
        transitionName = '';
      }

      this.transitionName = transitionName;

      if (this.transitionOverride) {
        this.transitionName = this.transitionOverride;
        this.transitionOverride = null;
      }

      gtag('event', 'screen_view', {
        'screen_name': to.name
      });
    },
  },
  methods: {
  },
  mounted() {
    if (!this.hasSeenIntro && this.$root.app) {
      this.$router.replace('/intro');
    }
  }
};
</script>

<style src="./css/app.less" lang="less"></style>



// WEBPACK FOOTER //
// src/App.vue